import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLogOut = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-log-out" data-icon="icon-log-out" aria-hidden="true" {...props} ref={ref}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>);
});

IconLogOut.displayName = 'IconLogOut';
